import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { SwitchContainer } from "./Switch.styles";

export const Switch = ({
  defaultValue = true,
  // Pass `value` to drive the switch from the caller's own state. Leave it
  // undefined and the switch keeps its position itself, as before.
  value = undefined,
  size = "small",
  onChange = undefined,
  backgroundColor = "#101c42",
  disabled = false,
}) => {
  const [internalChecked, setInternalChecked] = useState(defaultValue);

  const isControlled = value !== undefined;
  const checked = isControlled ? value : internalChecked;

  useEffect(() => {
    setInternalChecked(defaultValue);
  }, [defaultValue]);

  const handleChange = () => {
    if (disabled) return;
    // A controlled switch moves only when the caller says so, so a request
    // that fails leaves it showing the truth rather than the attempt.
    if (!isControlled) setInternalChecked(!checked);
    if (onChange) onChange(!checked);
  };

  return (
    <SwitchContainer>
      <div className={`secondary size-${size} ${disabled ? "disabled" : ""}`}>
        <label>
          <input
            type="checkbox"
            checked={checked}
            onChange={handleChange}
            disabled={disabled}
          />
          <span
            className={`slider size-${size}`}
            style={{ backgroundColor }}
          ></span>
        </label>
      </div>
    </SwitchContainer>
  );
};

Switch.propTypes = {
  defaultValue: PropTypes.bool,
  value: PropTypes.bool,
  backgroundColor: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};
